export const COLORS = {
    red: '#DA5959',
    green: '#50B171',
    blue: '#0A84FF',
    black: '#000000',
    grey: '#848484',
}

export default COLORS;